import { APPROVAL_REQUEST_FILTERS } from '../../../constants/FilterConstants'
import { APPROVAL_REQUEST_CONFIG } from '../../../constants/ApprovalRequestConstants'
import {
  setApprovalRequestsFilter,
  setApprovalRequestsGroupByAICode,
  setApprovalRequestsDistantSchools,
  setApprovalRequestAiCodeFilter,
} from '../../../actions/filters'
import { clearSelectedApprovalRequest } from '../../../actions/approvalRequests'
import {
  selectSelectedApprovalRequest,
  selectApprovalRequestType,
  selectFilteredApprovalRequests,
} from '../../../selectors/approvalRequests'
import { selectCurrentFilter } from '../../../selectors/filters'
import { BasicSelect, BasicText } from '../../common'

const mapStateToProps = state => {
  const { filter, groupByAICode, filterDistantSchools, filterAiCode } = selectCurrentFilter(state)
  const visibleApprovalRequests = selectFilteredApprovalRequests(state) || []
  const arType = selectApprovalRequestType(state)
  return {
    filter,
    groupByAICode,
    filterDistantSchools,
    filterAiCode,
    approvalRequest: selectSelectedApprovalRequest(state),
    arType,
    visibleApprovalRequestIds: visibleApprovalRequests.map(
      ar => ar[APPROVAL_REQUEST_CONFIG[arType].idField]
    ),
  }
}

export const ApprovalRequestsFilterControl = connect(mapStateToProps, {
  setApprovalRequestsFilter,
  setApprovalRequestsGroupByAICode,
  setApprovalRequestsDistantSchools,
  setApprovalRequestAiCodeFilter,
  clearSelectedApprovalRequest,
})(
  ({
    filter,
    groupByAICode,
    filterDistantSchools,
    filterAiCode,
    approvalRequest,
    arType,
    visibleApprovalRequestIds,
    setApprovalRequestsFilter,
    setApprovalRequestsGroupByAICode,
    setApprovalRequestsDistantSchools,
    setApprovalRequestAiCodeFilter,
    clearSelectedApprovalRequest,
  }) => {
    useEffect(() => {
      if (
        approvalRequest &&
        visibleApprovalRequestIds.findIndex(
          id => id === approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]
        ) === -1
      ) {
        clearSelectedApprovalRequest()
      }
    }, [visibleApprovalRequestIds])

    const filterOptions = Object.keys(APPROVAL_REQUEST_FILTERS).map(
      key => APPROVAL_REQUEST_FILTERS[key]
    )

    const handleChangeDistantSchools = () => {
      setApprovalRequestsDistantSchools(!filterDistantSchools, arType)
    }

    const handleChangeGroupByAICode = () => {
      setApprovalRequestsGroupByAICode(!groupByAICode, arType)
    }

    const handleChangeFilter = e => {
      setApprovalRequestsFilter(e.target.value, arType)
    }

    const handleChangeAiCodeFilter = e => {
      setApprovalRequestAiCodeFilter(e.target.value, arType)
    }

    return (
      <div className="form-group" style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div>
          <div className="checkbox" style={{}}>
            <label htmlFor="distantFilter">
              <input
                type="checkbox"
                className="cb-checkbox"
                id="distantFilter"
                aria-label="Outside the Continental U.S."
                checked={filterDistantSchools}
                onChange={() => handleChangeDistantSchools()}
              />
              <span className="cb-span" />
              Outside the Contiguous U.S.
            </label>
          </div>
          <div className="checkbox">
            <label htmlFor="groupByAICode">
              <input
                type="checkbox"
                className="cb-checkbox"
                id="groupByAICode"
                aria-label="Group By AI Code"
                checked={groupByAICode}
                onChange={() => handleChangeGroupByAICode()}
              />
              <span className="cb-span" />
              Group By AI Code
            </label>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ width: '200px', marginLeft: '15px' }}>
            <BasicText
              name="aiCodeFilter"
              value={filterAiCode}
              srOnlyLabel={true}
              placeholder="AI Code"
              maxlength="8"
              isSearchBox={true}
              input={{
                name: 'filterAiCode',
                value: filterAiCode,
                onChange: e => handleChangeAiCodeFilter(e),
              }}
            />
          </div>
          <div style={{ width: '200px', marginLeft: '15px' }}>
            <BasicSelect
              srOnlyLabel={true}
              label="Select filter"
              showEmptyOption={false}
              input={{
                name: 'statusFilterSelect',
                value: filter,
                onChange: e => handleChangeFilter(e),
              }}
              options={filterOptions}
            />
          </div>
        </div>
      </div>
    )
  }
)
